import { curry } from 'ramda'
import React from 'react'

import { ResultList, sectionTitleRow } from '../../../shared/ResultList.jsx'

import { FlightListElement } from './FlightListElement.jsx'
import { ListItemType } from './FlightSearchView.jsx'

export const FlightsList = ({ items, onFlightClick, onGetDirectionClick, T }) => {
  const _toUiItem = toUiItem(onFlightClick, onGetDirectionClick, T)
  const uiItems = items.map(_toUiItem)
  return <ResultList items={uiItems} />
}

const toUiItem = curry((onFlightClick, onGetDirectionClick, T, item) => {
  if (item.type === ListItemType.SECTION_TITLE)
    return sectionTitleRow(item.value)
  else return <FlightListElement
    data-cy='FlightListElement'
    onFlightClick={onFlightClick}
    onGetDirectionClick={onGetDirectionClick}
    flight={item.value}
    T={T}
  />
})
